module.exports = __webpack_public_path__ + "media/images/app/products/index/styles/rings/stackable-28682037cd8ac7789807a20e1001d25e.webp";